import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import { useAuth } from '../contexts/AuthContext';
import SEO from '../components/SEO';
import LandingNav from '../components/Layout/LandingNav';
import LandingFooter from '../components/Layout/LandingFooter';

function NotFound() {
  const { theme } = useTheme();
  const { user } = useAuth();
  const d = theme === 'dark';
  const isLoggedIn = !!user;

  return (
    <div className={`min-h-screen flex flex-col ${d ? 'bg-[#0a0a0a]' : 'bg-white'}`}>
      <SEO
        title="Page not found"
        description="The page you're looking for doesn't exist on PaperBrainz."
        path="/404"
      />
      <LandingNav />

      <div className="flex-1 flex items-center justify-center px-4 sm:px-6 lg:px-8 pt-32 sm:pt-40 pb-24 sm:pb-32">
        <div className="text-center max-w-xl mx-auto">
          <p className={`text-xs uppercase tracking-[0.2em] font-medium mb-5 ${d ? 'text-gray-500' : 'text-gray-500'}`}>
            404 — Page not found
          </p>
          <h1 className={`text-5xl md:text-6xl lg:text-[64px] font-semibold tracking-tight leading-[1.05] mb-5 ${d ? 'text-white' : 'text-gray-900'}`}>
            We couldn't find<br className="hidden sm:block" /> that page.
          </h1>
          <p className={`text-lg md:text-xl font-light leading-relaxed mb-10 ${d ? 'text-gray-500' : 'text-gray-500'}`}>
            The link might be broken, or the page may have moved. Let's get you back somewhere useful.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 justify-center items-center">
            <Link
              to={isLoggedIn ? '/dashboard' : '/'}
              className={`px-7 py-3.5 rounded-full transition-colors font-medium text-[15px] ${
                d ? 'bg-white text-black hover:bg-gray-200' : 'bg-gray-900 text-white hover:bg-black'
              }`}
            >
              {isLoggedIn ? 'Back to dashboard' : 'Back to home'}
            </Link>
            <a
              href="mailto:support@paperbrainz.com"
              className={`px-7 py-3.5 rounded-full transition-colors font-medium text-[15px] border ${
                d ? 'text-white border-white/15 hover:bg-white/[0.04]' : 'text-gray-900 border-gray-300 hover:bg-gray-50'
              }`}
            >
              Contact support
            </a>
          </div>
        </div>
      </div>

      <LandingFooter />
    </div>
  );
}

export default NotFound;
